var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.presentation.isEnablePrivateFeedback)?_c('div',{staticClass:"tabs",class:{
    light: _vm.isLightTheme,
    dark: !_vm.isLightTheme
  }},[_c('div',{staticClass:"tabs-container",class:{
      light: _vm.isLightTheme,
      dark: !_vm.isLightTheme
    }},[_c('div',{staticClass:"nav-tabs"},[_c('div',{staticClass:"nav-item",class:{
          active: _vm.activeTabView === 'slide',
          light: _vm.isLightTheme,
          dark: !_vm.isLightTheme
        },attrs:{"open-on-click":false},on:{"click":function($event){return _vm.handleSwitchTab('slide')}}},[_c('aha-icon',{attrs:{"name":"present"}})],1),_c('div',{staticClass:"nav-item",class:{
          active: _vm.activeTabView === 'feedback',
          light: _vm.isLightTheme,
          dark: !_vm.isLightTheme
        },on:{"click":function($event){return _vm.handleSwitchTab('feedback')}}},[_c('aha-icon',{attrs:{"name":"feedback"}})],1)])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }